import { render } from "./OAuthConfirmDialog.vue?vue&type=template&id=33f8261f"
import script from "./OAuthConfirmDialog.vue?vue&type=script&lang=js"
export * from "./OAuthConfirmDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__